module.exports = "/cyber/_next/static/images/DesktopWidgetPS-8c860f76d893ee2ab3a4f18af44bc998.png";